class OpoFlowBuyNow extends HTMLElement {
  #busy = false;
  connectedCallback() { this.addEventListener('click', this.#handleClick); }
  disconnectedCallback() { this.removeEventListener('click', this.#handleClick); }
  #handleClick = (event) => {
    const link = event.target.closest('[data-opoflow-buy-now]');
    if (!link || !this.contains(link)) return;
    if (this.#busy) { event.preventDefault(); return; }
    const gate = this.querySelector('[data-opoflow-invoice-choice][data-scope="buy-now"]');
    const chooser = window.OpoflowInvoiceChoice;
    if (!gate || !chooser?.open) return;
    event.preventDefault();
    chooser.open(gate, async (attributes) => {
      if (this.#busy) return;
      this.#busy = true;
      link.setAttribute('aria-busy', 'true');
      const form = this.closest('form');
      const variantId = form?.querySelector('input[name="id"]')?.value || this.getAttribute('data-variant-id');
      const quantityValue = form?.querySelector('input[name="quantity"]')?.value;
      const quantity = Math.max(1, Number.parseInt(quantityValue || this.getAttribute('data-quantity') || '1', 10) || 1);
      const root = window.Shopify?.routes?.root || '/';
      const base = root.endsWith('/') ? root : root + '/';
      const json = async (path, options = {}) => {
        const response = await fetch(base + path, { credentials: 'same-origin', ...options });
        if (!response.ok) throw new Error('Cart request failed');
        return response.json();
      };
      const post = (path, body) => json(path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      try {
        if (!variantId) throw new Error('Missing variant');
        const cart = await json('cart.js');
        const existing = cart.items.filter(item => String(item.variant_id) === String(variantId)).reduce((total, item) => total + item.quantity, 0);
        if (existing < quantity) await post('cart/add.js', { items: [{ id: variantId, quantity: quantity - existing }] });
        // Retain all existing lines, attributes and discounts; only save the selected invoice preference.
        await post('cart/update.js', { attributes: { ...cart.attributes, ...attributes } });
        window.location.assign(base + 'checkout');
      } catch (_error) {
        let message = this.querySelector('[data-opo-checkout-error]');
        if (!message) {
          message = document.createElement('p');
          message.setAttribute('data-opo-checkout-error', '');
          message.setAttribute('role', 'alert');
          link.insertAdjacentElement('afterend', message);
        }
        message.textContent = 'No hemos podido abrir el pago. Tu carrito se conserva. Abre el carrito e inténtalo de nuevo.';
      } finally {
        this.#busy = false;
        link.removeAttribute('aria-busy');
      }
    });
  };
}
if (!customElements.get('opoflow-buy-now')) customElements.define('opoflow-buy-now', OpoFlowBuyNow);
